import { useContext } from 'react';
import AuthContext from '../components/auth/AuthProvider';

const useAuth = () => useContext(AuthContext);

export default useAuth;
